import {
  TComponentKeys,
} from '@/types/openapi-type.ts';

const tooltip: TComponentKeys<'AuditTrailSettings'> = {
  isEnabled: 'Určuje, či je auditný záznam povolený. Ak je zakázaný, žiadne udalosti sa nebudú zaznamenávať.',
  retentionPeriodDays: 'Určuje, ako dlho sa udalosti uchovávajú. Staré udalosti sa odstraňujú každú hodinu. Maximálna doba je 31 dní.',
};

export default {
  tooltip,
};
